import { render, staticRenderFns } from "./FarmHarvestMessage.vue?vue&type=template&id=5a05cd35"
import script from "./FarmHarvestMessage.vue?vue&type=script&lang=js"
export * from "./FarmHarvestMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports